export const getCampaignTab = ({ campaignTab }) => campaignTab;
